// extracted by mini-css-extract-plugin
export default {"shopping":"Shopping_shopping__ZDRV2"};